import { createSelector } from 'reselect'
import { getCurrentModalSelect } from 'modules/modal/selectors'
import { MODAL_ID } from 'modules/modal/constants/index.cjs'

/**
 * Check if the Android download modal is currently open
 * @return {boolean}
 */
export const isAndroidDownloadModalOpenSelect = createSelector(
  getCurrentModalSelect,
  (currentModal) => currentModal === MODAL_ID.ANDROID_DOWNLOAD
)
